// Ambiente definido pelo host do portal (mesma regra do http-client): "-sand" na URL aponta para o sandbox
export const isSandbox = (): boolean => window.location.hostname.includes('-sand');

const PORTAL_DOMAIN = 'docgedsistemas.com.br';
const isLocalhost = (): boolean => ['localhost', '127.0.0.1'].includes(window.location.hostname);

// Rodando local também usa os sistemas do sandbox, nunca os de produção
const suffix = () => (isSandbox() || isLocalhost() ? '-sand' : '');

/** Área Administrativa (APM) do ambiente atual. */
export const adminUrl = (): string => `https://apm${suffix()}.${PORTAL_DOMAIN}`;

/** SCP do ambiente atual. */
export const scpUrl = (): string => `https://scp${suffix()}.${PORTAL_DOMAIN}`;

/** SGE (Sistema de Gestão de Emendas) do ambiente atual. */
export const sgeUrl = (): string => `https://sge${suffix()}.${PORTAL_DOMAIN}`;
